<template>
  <v-footer color="primary white--text" class>
    <v-spacer></v-spacer>
    <div>&copy; Fernando Martins - 2020</div>
    <v-spacer></v-spacer>
  </v-footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>
